export default __webpack_public_path__ + "static/media/pics.17bc10bb.svg";